import PropTypes from 'prop-types';
import React from 'react';
import { isEmpty } from 'lodash';
import { Avatar, AvatarImage } from '@fiverr-private/avatar';
import { Text } from '@fiverr-private/typography';
import { Stack } from '@fiverr-private/layout_components';
import { I18n } from '@fiverr-private/i18n-react';
import { RepeatIcon } from '@fiverr-private/icons';
import ProClientBadge from '../../../../../shared/ProClient/ProClientBadge';
import Country from '../../../../../shared/ReviewerSubDetails/Country';
import { shouldDisplayIndustryFilter } from '../../../../../../utils/industries';
import Industry from '../../../../../shared/ReviewerSubDetails/Industry';

export const DesktopView = ({ user, showBusinessBadge, countryCode, isRepeatBuyer, reviewerIndustry }) => {
    const displayIndustry = shouldDisplayIndustryFilter() && !isEmpty(reviewerIndustry);
    return (
        <Stack justifyContent="spaceBetween" gap="3" direction="row">
            <Stack gap="4">
                <Avatar size="md" username={user.username}>
                    {user.has_profile_photo ? <AvatarImage alt="image-docs" src={user.profile_photo} /> : null}
                </Avatar>
                <Stack direction="column" gap="0" justifyContent="spaceBetween">
                    <Stack withDivider alignItems="center" direction="row" gap="3" dividerProps={{ variant: 'dot' }}>
                        <Stack alignItems="center">
                            <Text fontWeight="bold">{user.username}</Text>
                        </Stack>
                        {isRepeatBuyer && (
                            <Stack alignItems="center" gap="1">
                                <RepeatIcon />
                                <Text fontWeight="semibold" size="b_sm">
                                    <I18n k="reviews.header.repeat_client" />
                                </Text>
                            </Stack>
                        )}
                        {showBusinessBadge && <ProClientBadge />}
                    </Stack>
                    <Stack withDivider dividerProps={{ variant: 'dot' }}>
                        {countryCode && <Country code={countryCode} />}
                        {displayIndustry ? <Industry reviewerIndustry={reviewerIndustry} /> : null}
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    );
};

DesktopView.propTypes = {
    user: PropTypes.shape({
        has_profile_photo: PropTypes.bool.isRequired,
        username: PropTypes.string.isRequired,
        profile_photo: PropTypes.string,
    }).isRequired,
    showBusinessBadge: PropTypes.bool.isRequired,
    isRepeatBuyer: PropTypes.bool.isRequired || null,
    reviewerIndustry: PropTypes.array,
    countryCode: PropTypes.string.isRequired,
};
